<ng-container *transloco="let t">
  <app-page-template [isLanding]="true">
    <div class="container">
      <div class="search-container d-flex justify-content-center align-items-center flex-column flex-xxl-row">
        <app-search-bar-events [isTransparent]="true"/>
      </div>
      <div class="banner">
        <img alt="We trace you race" src="assets/img/cpr_transparent.png" class="img-fluid" width="350">
      </div>
      <section class="pb-50">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <app-grid-item-title [title]="t('app.landing.upcoming.events')"/>
          <div class="d-flex justify-content-end">
            <i class="bi bi-chevron-left cursor-pointer" [class.disabled]="isFirstSlideActive(upcomingEventsSwiper)"
               (click)="slidePrev(upcomingEventsSwiper)"></i>
            <i class="bi bi-chevron-right cursor-pointer ms-3"
               [class.disabled]="isLastSlideActive(upcomingEventsSwiper)" (click)="slideNext(upcomingEventsSwiper)"></i>
          </div>
        </div>
        <div [@fadeIn]="fadeState">
          @if (upcomingItems.length ?? 0 > 0) {
            <swiper #upcomingEventsSwiper [slidesPerView]="3" [spaceBetween]="40" [breakpoints]="breakpoints">
              @for (item of upcomingItems;track trackByFn;let last = $last) {
                <ng-template swiperSlide>
                  @if (!last) {
                    <div>
                      <app-event-grid-item-with-image [eventItem]="item" [countries]="countries" [isLanding]="true"
                                                      [zoomEffect]="true" (click)="goToEventDetailsPage(item)"
                                                      [languages]="languages"/>
                    </div>
                  } @else {
                    <div class="explore-all">
                      <button class="explore-all__button" (click)="exploreAll()">
                        >> {{ t('app.landing.explore.all') }}
                      </button>
                    </div>
                  }
                </ng-template>
              }
            </swiper>
          } @else {
            <app-empty-state/>
          }
        </div>
      </section>
    </div>

    <section class="new-events-container container-fluid pb-80-67 pt-30-28">
      <div class="container">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <app-grid-item-title [title]="t('app.landing.new.events')"/>
          <div class="d-flex justify-content-end">
            <i class="bi bi-chevron-left cursor-pointer" [class.disabled]="isFirstSlideActive(newEventsSwiper)"
               (click)="slidePrev(newEventsSwiper)"></i>
            <i class="bi bi-chevron-right cursor-pointer ms-3" [class.disabled]="isLastSlideActive(newEventsSwiper)"
               (click)="slideNext(newEventsSwiper)"></i>
          </div>
        </div>
        <div [@fadeIn]="fadeState">
          @if (newItems.length ?? 0 > 0) {
            <swiper #newEventsSwiper [slidesPerView]="3" [spaceBetween]="40" [breakpoints]="breakpoints">
              @for (item of newItems;track trackByFn;let last = $last) {
                <ng-template swiperSlide>
                  @if (!last) {
                    <div>
                      <app-event-grid-item-with-image [eventItem]="item" [countries]="countries" [isLanding]="true"
                                                      [zoomEffect]="true" (click)="goToEventDetailsPage(item)"
                                                      [languages]="languages"/>
                    </div>
                  } @else {
                    <div class="explore-all">
                      <button class="explore-all__button" (click)="exploreAll()">
                        >> {{ t('app.landing.explore.all') }}
                      </button>
                    </div>
                  }
                </ng-template>
              }
            </swiper>
          } @else {
            <app-empty-state/>
          }
        </div>
      </div>
    </section>

    <div class="your-sport-container-title container-fluid pt-30-28">
      <div class="container">
        <app-grid-item-title [title]="t('app.landing.your.sport')"/>
      </div>
    </div>

    <section class="your-sport-container container-fluid pb-80-67">
      <div class="container container-fixed-sm">
        <div class="row d-flex">
          @for (sport of sports;track sport) {
            <div class="col">
              <div class="d-flex flex-column justify-content-center align-items-center">
                <div class="sport-icon-wrapper">
                  @if (sport.imgSrc) {
                    <img [src]="sport.imgSrc" alt="{{ t(sport.buttonTextKey) }}">
                  }
                </div>
                <app-rounded-button [label]="t(sport.buttonTextKey)" [btnClass]="sport.buttonClass"
                                    (onClick)="explore(sport.id)"/>
              </div>
            </div>
          }
        </div>
      </div>
    </section>
    <app-footer/>
  </app-page-template>
</ng-container>

